import React from "react";
import styled from "styled-components";

interface IProps {
  children: React.ReactNode;
}

const StyledDialogHeading = styled.div`
  flex: 0 0 66%;
  padding: ${({ theme }) => theme.space[2]};
  border-radius: ${({ theme }) => theme.radii[1]};
  color: ${({ theme }) => theme.colors.primary};
  font-family: ${({ theme }) => theme.fonts.impact};
  font-size: ${({ theme }) => theme.fontSizes[6]};
  font-weight: normal;
  line-height: 26px;

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    font-size: ${({ theme }) => theme.fontSizes[7]};
  }
`;

const DialogHeading: React.FC<IProps> = ({ children }) => {
  return <StyledDialogHeading>{children}</StyledDialogHeading>;
};

export default DialogHeading;
